import {
  TROUBLE_SHOOTING_EVENTS_TAB_LOAD_DATA,
  TROUBLE_SHOOTING_EVENTS_TAB_LOAD_DATA_RESULT
} from 'Redux/actionTypes';

export const troubleShootingEventsTabGetData = (deviceId,  accountId, nextToken, limit, filters) => ({
  type: TROUBLE_SHOOTING_EVENTS_TAB_LOAD_DATA,
  payload: { deviceId,  accountId, nextToken, limit, filters }
});

export const troubleShootingEventsTabGetDataResult = (data) => ({
  type: TROUBLE_SHOOTING_EVENTS_TAB_LOAD_DATA_RESULT,
  payload: data
});